module.exports = __webpack_public_path__ + "img/pdf_vision_hypergraph.c5b45d1e.jpg";